<template>
  <div :class="$style.nav">
    <router-link to="/">Overview</router-link>
    <router-link to="/users">Users</router-link>
    <router-link to="/training">Training</router-link>
    <router-link to="/promos">Promos</router-link>
    <router-link to="/pixel-test">Pixel Test</router-link>
    <router-link to="/team-dashboard">Team Dashboard</router-link>
    <router-link to="/count">Customer Button</router-link>
    <a href="" @click="signOut()">Logout</a>
  </div>
</template>

<script>
  import constants from '../../../../constants'
  export default {
    name: 'Nav',
    methods: {
      signOut () {
        console.log('signout')
        this.$store.commit(constants.SIGN_OUT)
      }
    }
  }
</script>

<style lang="scss" module>
  .nav {
    position: relative;
    border-top: 2px solid rgba(113, 126, 131, 0.2);
    padding: 5px 0;

    a {
      display: inline-block;
      padding: 10px;
      line-height: 1em;
      color: rgb(113, 126, 131);
      text-decoration: none;
      font-weight: bold;
      border-radius: 4px;

      &:hover {
        background-color: rgba(white, 0.05);
        color: white;
      }
    }
  }
</style>

<style lang="scss">
  .router-link-exact-active {
    background-color: rgba(white, 0.05);
    color: white !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/lib/Header/Nav/index.vue